import { render, staticRenderFns } from "./BoletinDetalle.vue?vue&type=template&id=2cb5c92e&scoped=true"
import script from "./BoletinDetalle.vue?vue&type=script&lang=js"
export * from "./BoletinDetalle.vue?vue&type=script&lang=js"
import style0 from "./BoletinDetalle.vue?vue&type=style&index=0&id=2cb5c92e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb5c92e",
  null
  
)

export default component.exports